import { Dispatch, SetStateAction, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppDispatch } from '../../../app/hooks';
import { SelectNetwork } from '../../../components';
import { CheckText } from '../../../components/common/CheckText';
import { Hub } from '../../../components/common/Hub/Hub';
import { SendingTokenType, formatUSD } from '../../../helpers/helperFunctions';
import { CaptionText, H2, P1, P3 } from '../../../styles/FontStyles';
import { Button, Flexed, SelectedUSDT } from '../../../styles/GlobalComponents';
import { color } from '../../../styles/GlobalStyles';
import { WalletsType } from '../../../types/types';
import { PurchaseSteps, Tokens } from '../Maeketplace.types';
import { SelectToken } from '../../../components/common/SelectNetwork/SelectToken';

interface PayTetherProps {
  setStep: Dispatch<SetStateAction<PurchaseSteps>>;
  selectedPackage: any;
  selectedLicence: any;
  selectedNetwork: WalletsType;
  setSelectedNetwork: Dispatch<SetStateAction<WalletsType>>;
  selectedToken: any;
  setSelectedToken: Dispatch<SetStateAction<any>>;
  setUsdt: Dispatch<SetStateAction<string>>;
  setUsdc: Dispatch<SetStateAction<string>>;
  lp: string;
  club: string;
  cash: string;
  calculatedPrice: string;
  handlePay: (step: PurchaseSteps) => void;
}

export const PayTether = ({
  selectedPackage,
  selectedLicence,
  selectedNetwork,
  setSelectedNetwork,
  selectedToken,
  setSelectedToken,
  setUsdt,
  setUsdc,
  calculatedPrice,
  handlePay
}: PayTetherProps) => {
  const { t } = useTranslation('marketplace');

  const [checkbox, setCheckbox] = useState(false);

  const handlePayTether = (event: any) => {
    event.currentTarget.disabled = true;
    handlePay(PurchaseSteps.SUCCESS);
  };

  const {
    image,
    name,
    price,
    weeklyCap,
    packageId,
    limitedQuantity,
    calculator,
    tradingBinaryPercentage,
    willyMemeCoins,
    subtitle,
    tickets,
    subscriptionPrice
    // eslint-disable-next-line no-unsafe-optional-chaining
  } = selectedPackage;

  const amountToPay = selectedLicence
    ? subscriptionPrice
      ? selectedLicence.price + price + subscriptionPrice
      : selectedLicence.price + price
    : subscriptionPrice
    ? subscriptionPrice + price
    : price;

  return (
    <div>
      <P1 bold mb='20'>
        {t('selected_package')}:
      </P1>

      <Hub
        key={packageId}
        condensed
        showTickets={packageId >= 170 && packageId < 180}
        image={image}
        title={name}
        weeklyCap={weeklyCap}
        limitedQuantity={limitedQuantity}
        dobuleTradingBinaries={tradingBinaryPercentage}
        price={subscriptionPrice ? price : amountToPay}
        subscriptionPrice={subscriptionPrice}
        selectedLicence={selectedLicence}
        packagePrice={price}
        includesSubscription={selectedLicence?.access}
        willyMemeCoins={willyMemeCoins}
        subtitle={subtitle}
        tickets={tickets}
        info={
          <>
            {calculator && (
              <Flexed alignEnd end>
                <H2 bold mr='16' alignEnd>
                  {calculator}
                </H2>
                <CaptionText bold right mb='4'>
                  {t('reward')}
                  <br /> {t('multiplicator')}
                </CaptionText>
              </Flexed>
            )}
          </>
        }
      />

      <P3 mb='8'>{t('payment_method.small_text2')}</P3>

      <P3 bold mb='8' mt='20' color={color.colors.neutral900}>
        {t('payment_method.payment_ammount')}
      </P3>

      <SelectedUSDT>
        {calculatedPrice
          ? formatUSD(Number(calculatedPrice))
          : formatUSD(amountToPay)}
      </SelectedUSDT>

      <P3 bold mb='8' mt='20' color={color.colors.neutral900}>
        {t('selected_network')}
      </P3>

      <SelectNetwork
        onChange={(n) => setSelectedNetwork(n)}
        value={selectedNetwork}
      />

      <P3 bold mb='8' mt='20' color={color.colors.neutral900}>
        {t('select_token')}
      </P3>

      <SelectToken
        onChange={(token) => {
          setSelectedToken(token);

          if (token.index === Tokens.TETHER) {
            if (calculatedPrice) {
              setUsdt(calculatedPrice);
            } else {
              setUsdt(amountToPay.toString());
            }

            setUsdc('');
          } else {
            if (calculatedPrice) {
              setUsdc(calculatedPrice);
            } else {
              setUsdc(amountToPay.toString());
            }
            setUsdt('');
          }
        }}
        value={selectedToken}
      />

      {selectedNetwork && (
        <P3 bold mb='25' color={color.colors.error500}>
          <SendingTokenType network={selectedNetwork?.networkType} />
        </P3>
      )}

      {selectedNetwork && (
        <CheckText
          checked={checkbox}
          onClick={() => setCheckbox(!checkbox)}
          text={t('payment_method.i_understand')}
        />
      )}

      <Button
        mt={20}
        disabled={!selectedNetwork || !checkbox || !selectedToken}
        onClick={handlePayTether}>
        {t('payment_method.create_order')}
      </Button>
    </div>
  );
};
